(function () {
  function initHowTo(root) {
    if (!root) return;

    var steps = Array.prototype.slice.call(
      root.querySelectorAll('[data-wondr-srz-howto-step]')
    );

    var images = Array.prototype.slice.call(
      root.querySelectorAll('[data-wondr-srz-howto-img]')
    );

    var stepLabel = root.querySelector('[data-wondr-srz-howto-step-label]');
    var stepTitle = root.querySelector('[data-wondr-srz-howto-step-title]');

    function syncCaption(index) {
      var activeStepIndex = index + 1;
      var active = steps[index];

      if (stepLabel) {
        stepLabel.textContent = 'Stap ' + activeStepIndex + ' van ' + steps.length;
      }

      if (stepTitle && active) {
        stepTitle.textContent = active.getAttribute('data-title') || '';
      }
    }

    function syncImages(index) {
      var activeStepIndex = index + 1;

      images.forEach(function (img) {
        var imageStepIndex = parseInt(img.getAttribute('data-wondr-srz-howto-img-index'), 10);
        img.classList.toggle('is-active', imageStepIndex === activeStepIndex);
      });

      syncCaption(index);
    }

    function activate(index) {
      steps.forEach(function (step, stepIndex) {
        var isActive = stepIndex === index;
        step.classList.toggle('is-active', isActive);

        var header = step.querySelector('[data-wondr-srz-howto-step-header]');
        if (header) {
          header.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        }
      });

      syncImages(index);
    }

    function closeStep(step) {
      step.classList.remove('is-active');
      var header = step.querySelector('[data-wondr-srz-howto-step-header]');
      if (header) {
        header.setAttribute('aria-expanded', 'false');
      }
    }

    steps.forEach(function (step, index) {
      if (step.dataset.wondrSrzHowtoBound === 'true') return;

      step.dataset.wondrSrzHowtoBound = 'true';

      var isAccordion = step.getAttribute('data-accordion') === 'true';

      if (isAccordion) {
        step.addEventListener('click', function (event) {
          // Open body click → show this step's image (legacy activate image sync)
          if (event.target.closest('[data-wondr-srz-howto-step-panel]')) {
            syncImages(index);
            return;
          }

          // Title / num / chevron → toggle open/close
          if (step.classList.contains('is-active')) {
            closeStep(step);
            return;
          }

          activate(index);
        });

        var header = step.querySelector('[data-wondr-srz-howto-step-header]');
        if (header) {
          header.addEventListener('keydown', function (event) {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();

            if (step.classList.contains('is-active')) {
              closeStep(step);
              return;
            }

            activate(index);
          });
        }

        return;
      }

      step.addEventListener('click', function () {
        activate(index);
      });
    });

    var activeIndex = steps.findIndex(function (step) {
      return step.classList.contains('is-active');
    });

    // Legacy: ensure a non-accordion step is active.
    // Accordion-only: leave all closed; first image stays from Liquid.
    if (activeIndex > -1) {
      activate(activeIndex);
    } else {
      var firstLegacy = steps.findIndex(function (step) {
        return step.getAttribute('data-accordion') !== 'true';
      });

      if (firstLegacy > -1) {
        activate(firstLegacy);
      } else if (steps.length) {
        syncImages(0);
      }
    }
  }

  function initAll(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-wondr-srz-howto]').forEach(function (section) {
      initHowTo(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
